import CardList from "../../components/styled/CardList";
import CardTitle from "../../components/styled/CardTitle";
import { arrayMap } from "../../utils/array.utils";
import { viewDeliveryFormatterFunc } from "../../utils/moneyReceipt.utils";

export default function DeliveryInformation({ data }) {
  const delivery = data?.customer?.delivery;
  const formattedData = viewDeliveryFormatterFunc(delivery);
  return (
    <div className="card border-0">
      <div className="card-body">
        <CardTitle>Delivery Information</CardTitle>
        <CardList className="list-unstyled mb-0">
          {arrayMap(formattedData, (item, index) => (
            <li key={index}>
              <b>{item.label}</b>: {item.value}
            </li>
          ))}
        </CardList>
      </div>
    </div>
  );
}
